module.exports = __webpack_public_path__ + "static/media/hanoi_f_thumb_even.c6bf31ca.jpg";